import axios from 'axios'

const baseURL = process.env.VUE_APP_DROP_ORDER_SERVICE + '/api/admin/referrals'

export default {
  namespaced: true,
  state: {
    is_loading: null,
    is_processing: null,
    dropReferrals: []
  },
  mutations: {
    setDropReferrals (state, payload) {
      state.dropReferrals = payload
    },
    removeDropReferralItem (state, id) {
      const index = state.dropReferrals.findIndex(item => item.id === id)

      if (index !== -1) {
        state.dropReferrals.splice(index, 1)
      }
    }
  },
  actions: {
    async getDropReferrals ({ commit, state }) {
      state.is_loading = true
      const promise = axios.get(baseURL)

      promise.then(response => {
        commit('setDropReferrals', response.data.data)
        state.is_loading = false
      })
    },
    async getDropReferralUsers ({ commit, state }, id) {
      return axios.get(baseURL + '/' + id + '/users')
    },
    async createDropReferral ({ commit, state }, data) {
      state.is_processing = true
      const promise = axios.post(baseURL, data)

      promise.then(() => {
        state.is_processing = false
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    },
    async deleteDropReferral ({ commit, state }, id) {
      state.is_processing = true
      const promise = axios.delete(baseURL + '/' + id)

      promise.then(() => {
        state.is_processing = false
        commit('removeDropReferralItem', id)
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    }
  }
}
